module.exports = __webpack_public_path__ + "1011693a5106fd25d120085c281727f5.svg";